import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { CheckableSettings, FilterExpandSettings } from '@progress/kendo-angular-treeview';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { LocationDropDownModel } from 'src/app/shared/models/locations-drop-down-list.model';
import { LocationUsersDropDownModel } from 'src/app/shared/models/users-drop-down-list.model';
import { State } from 'src/app/state/app.state';

@Component({
    selector: 'user-selector-tree-view',
    templateUrl: './user-selector-tree-view.component.html',
    styleUrls: ['./user-selector-tree-view.component.scss']
})
export class UserSelectorTreeViewComponent {
    // get root locations ids as input
    @Input() expandedKeys: any[] = [];
    // get checked components Tree view unique id0
    @Input() selectedUserId: number = 0;
    @Input() locations: LocationUsersDropDownModel[] = [];
    @Input() dispatchStateEvent: boolean = true;

    @Output() closeEvent: EventEmitter<LocationUsersDropDownModel> = new EventEmitter<LocationUsersDropDownModel>();
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    public locationSelector: LocationUsersDropDownModel = {
        name: '',
        id: 0,
        locationId: 0,
        isUser: false,
        hasChild: false,
        items: []
    };

    // currently checked Tree view unique id
    public checkedKeys: any[] = [];
    public checkAll: boolean = true;

    // Checking component
    public key = 'id';

    constructor(private locationService: LocationService, private store: Store<State>) { }

    showClick(dataItem: LocationUsersDropDownModel) {
        this.locationSelector = dataItem;
        this.closeEvent.emit(this.locationSelector);
    }

    // check item has children
    public hasChildren(item: LocationDropDownModel) {
        return item.hasChild;
    }

    // fetch childrend data
    public fetchChildren = (item: any) => this.locationService.getHierarchyChildLocations(item.locationId);

    // checking settings
    public get checkableSettings(): CheckableSettings {
        return {
            checkChildren: true,
            checkParents: true,
            enabled: true,
            mode: 'multiple',
            checkOnClick: true,
        };
    }

    public filterExpandSettings: FilterExpandSettings = {
        maxAutoExpandResults: 4,
        expandedOnClear: "unchanged"
    };

    /**
 * Recursively adds location IDs to `expandedKeys` for expandable list items.
 * @param treeItem - Array of LocationDropDownModel objects to expand.
 * Updates `expandedKeys` to include IDs of items that should be expanded.
 */
    private addExpandListItem(treeItem?: LocationDropDownModel[]): void {
        if (!treeItem) return;
        treeItem.forEach(item => {
            this.expandedKeys.push(item.locationId);
            if (item.hasChild) {
                this.addExpandListItem(item.items)
            }
        });
    }
}
